var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "apple-pay-widget" },
    [
      _vm.isSupported
        ? _c("apple-pay-button", {
            attrs: { buttonstyle: "black", type: "buy", locale: "en-GB" },
            on: { click: _vm.onApplePayClicked },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }